import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { profileService } from '../services'
import { type ProfileUpdateData, type PasswordChangeData } from '../validation/schemas'
import { type User } from '../types'

// Query key for profile data
export const PROFILE_QUERY_KEY = ['profile']

// Hook to fetch current user profile
export const useProfile = () => {
  return useQuery({
    queryKey: PROFILE_QUERY_KEY,
    queryFn: () => profileService.getProfile(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}

// Hook to update user profile
export const useUpdateProfile = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: ProfileUpdateData) => profileService.updateProfile(data),
    onSuccess: (updatedUser: User) => {
      // Update the cached profile data
      queryClient.setQueryData(PROFILE_QUERY_KEY, updatedUser)
      // Also update the auth store user data
      queryClient.invalidateQueries({ queryKey: ['auth'] })
    },
  })
}

// Hook to change password
export const useChangePassword = () => {
  return useMutation({
    mutationFn: (data: PasswordChangeData) => profileService.changePassword(data),
  })
}
